import {ChangeDetectorRef, Component, forwardRef, Input, TemplateRef, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {SubscribedComponent} from "../../subscribed.component";
import {AuthService} from "../../shared/auth.service";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {NbDialogService} from "@nebular/theme";
import {PopupDialogComponent} from "../../dialogs/popup-dialog/popup-dialog.component";
import {ExperienceEditorComponent} from "./experience-editor/experience-editor.component";
import {Experience, ExperienceType} from "./experience";
import {Globals} from "../../shared/Globals";
import {NotifierService} from "../../shared/notifier.service";

@Component({
    selector: 'bst-experience-assigner',
    templateUrl: './experience-assigner.component.html',
    styleUrls: ['./experience-assigner.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ExperienceAssignerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ExperienceAssignerComponent extends SubscribedComponent implements ControlValueAccessor {

  @ViewChild('footer', {static: true}) footer: TemplateRef<any>;
  @Input() readonly: boolean = true;

  public disabled: boolean = false;
  public experiences: Experience[] = [];
  ExperienceType = ExperienceType;

  // Function to call when the value changes.
  onChange = (value: Experience[]) => {};
  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => {};

  constructor(public auth: AuthService,
              private translate: TranslateService,
              private dialog: NbDialogService,
              private detector: ChangeDetectorRef,
              private notifier: NotifierService,
              private router: Router) {
    super();
  }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: Experience[]): void {
    this.experiences = Array.from(value || []);

    // Convert dates
    this.experiences.forEach(experience => {
      if(experience.start){
        experience.start = Globals.fromDateString(experience.start);
      }
      if(experience.end){
        experience.end = Globals.fromDateString(experience.end);
      }

      if(experience.items){
        experience.items.forEach(item => {
          if(item.start){
            item.start = Globals.fromDateString(item.start);
          }
          if(item.end){
            item.end = Globals.fromDateString(item.end);
          }
        });
      }
    });

    this.onChange(this.experiences);
  }

  openExperience(item: Experience = null, subitem: Experience = null, type: ExperienceType = ExperienceType.CustomClient) {
    this.onTouched();
    this.subs.push(this.dialog.open<PopupDialogComponent<ExperienceEditorComponent>>(PopupDialogComponent, {
      context: {
        comp: ExperienceEditorComponent,
        title: (item ? item.type : type) === ExperienceType.School ? 'editeducation' : 'editexperience',
        componentContext: {
          experience: item,
          opento: subitem,
          type: item ? item.type : type
        },
        footer: this.footer
      },
      closeOnBackdropClick: true,
      closeOnEsc: true,
      autoFocus: true,
    }).onClose.subscribe((editor: ExperienceEditorComponent) => {
      if(editor){
        if(item) {
          const i = this.experiences.indexOf(editor.experience);
          if (i !== -1) {
            this.experiences[i] = editor.value;
          }
        }
        else{
          this.experiences.push(editor.value);
        }
        this.experiences = [...this.experiences];
        this.detector.detectChanges();
        this.onChange(this.experiences);
      }
    }));
  }

  async delete(popup: PopupDialogComponent<ExperienceEditorComponent>) {
    this.onTouched();
    const experience: Experience = popup.instance.experience;
    const i = this.experiences.indexOf(experience);
    if(i !== -1){
      if(await this.notifier.confirm('deletechecklight', experience.name, 'deleteforever', 'danger')){
        this.experiences.splice(i, 1);
        this.experiences = [...this.experiences];
        popup.done(null);
        this.onChange(this.experiences);
      }
    }
  }
}
